import { z } from 'zod';

import { getPastOneOnOneApi } from '../api';

const pastOneOnOnesValidator = z
  .array(
    z.object({
      completionStatus: z.enum(['YET_TO_START', 'CANCELLED', 'COMPLETED']),

      completionTime: z.coerce.date().nullable(),

      duration: z.number().nullable(),

      id: z.number(),
      legacyInstanceId: z.number().nullable(),
      masterId: z.number(),
      providerEmployeeId: z.number(),
      receiverEmployeeId: z.number(),
      relationType: z.enum(['MANAGER', 'SKIP_MANAGER', 'PEER', 'SKIP_REPORTEE', 'REPORTEE']),
      startTime: z.coerce.date(),
      startTimeTs: z.union([z.number(), z.null(), z.undefined()]),
    })
  )
  .nullable();

export const getPastOneOnOne = async ({ masterId }: { masterId: number }) => {
  try {
    const res = await getPastOneOnOneApi({ masterId });
    return pastOneOnOnesValidator.parse(res.entity);
  } catch (error) {
    console.error('Error fetching past one on one : ', error);
  }
};
